// const BASE_URL = 'http://dev.rybuy.cn'
const BASE_URL = 'https://www.sxbicsp.com/'
let url = '/api'
export default {
    BASE_URL: BASE_URL,
    REGISTER: url + '/member/register', // 用户注册
    CHECK_IS_EXIST: url + '/member/checkIsExist', // 检测用户名是否重复
    CODE: url + '/member/code', // 获取手机验证码
    MEMBER_LOGIN: url + '/member/login', // 用户登录
    MEMBER_FORGETPWD: url + '/member/forgetPwd', // 重置密码
    MEMBER_INFO: url + '/member/info', // 个人信息
    MEMBER_UPDATEIMGURL: url + '/member/updateImgUrl', // 上传头像
    MEMBER_SAVEMEMBER: url + '/member/saveMember', // 实名认证
    MEMBER_UPDATEPWD: url + '/member/updatePwd', // 修改密码
    MEMBER_LOGOUT: url + '/member/logout', // 退出登录

//    课程接口
    COURSE_DETAIL: url + '/app/studyCourse/courseDetail', // 课程详情
    MY_SECTION_LIST: url + '/app/studyCourse/mySectionList', // 章节和小节以及用户学习进度
    SAVE_PC_SECTION: url + '/app/studyCourse/savePcSection', // 保存学习进度
    MY_COURSE_PC_LIST: url + '/app/studyCourse/myCoursePcList', // 我的课程
    MY_SECTION_DETAIL: url + '/app/studyCourse/getVedioInfo', // 小节学习详情-暂时PC端使用
    SAVE_MEMBER_VEDIO_PHOTO_PC: url + '/app/studyCourse/saveMemberVedioPhotoPc', // 提交小节视频拍照-PC端用
    Member_Section_Photo_Info: url + '/app/studyCourse/getMemberSectionPhotoInfo', // 获取小节视频拍照-PC端用
    STATISTICS_STUDY_RECORD: url + '/app/studyCourse/statisticsStudyRecord', // 查询用户的学习记录（学时）-PC端用
    GET_MEMBER_SECTION_PHOTO_MINI_INFO: url + '/app/studyCourse/getMemberSectionPhotoMiniInfo', // 查询用户的小节小程序拍照图-PC端用
    REMOVE_MEMBER_SECTION_PHOTO_MINI_INFO: url + '/app/studyCourse/removeMemberSectionPhotoMiniInfo', // 用户小程序拍照完确定无误，移除小程序拍照缓存-PC端用
//
}
